import Api from ".";
import { store } from "../store/store";
import { DEVURL } from "./envUrl";
import {
  acpBookingCapacityValuesData,
  acpBookingData,
  updateRTATasksResponse,
  emptyErrorData,
  acpDashboardProjectsRequiringPM,
} from "../store/actions/AcpBookingActions";
import {
  acpPlanningData,
  acpPlanningProjectData,
  setAcpPlanningProjectCapacityValuesData,
} from "../store/actions/AcpPlanningActions";
import { AcpService } from "../service/ACPService";
import { AcpCommonService } from "../service/AcpCommonService";
import { removeKey } from "../service/DashboardService";
import { CIC_DEPENDENT, NOT_NEEDED } from "../Utils/constants";
import { convertBooleanToString, changeDateFormat } from "../utils";

export const getAcpBookingData = async (
  userInformation,
  user_group,
  bookingTableFilters,
  headers = {}
) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
      PM: userInformation?.userid,
      Start_Date: bookingTableFilters?.Date && AcpService?.convertDate(bookingTableFilters?.Date),
      End_Date:
        bookingTableFilters?.endDate && AcpService?.convertDate(bookingTableFilters?.endDate),
    },
  };
  let apiURL = `${DEVURL}/fetchACPBooking`;
  const response = await axiosInstance({
    url: apiURL,
    data: payLoad,
    method: "POST",
  });
  let AcpBookingResponse = !AcpService.isUBN(response?.data) ? response.data : [];
  let AcpBookingCapacityValuesResponse = response?.data?.CapacityValues;
  if (Object.keys(AcpBookingResponse)?.length) {
    let ArtworkAgilityProjects = [AcpBookingResponse];
    let arr = ArtworkAgilityProjects.map((obj) => {
      Object.values(obj).map((el) => {
        el?.map((_el) => {
          if (_el?.RequestStatus === "Awaiting Response") {
            _el.StartDate = _el?.UpdatedStartDate;
          }
          //AWM-3993: updated CIC Needed values
          if(_el?.AWM_CICNeeded === "No") _el.AWM_CICNeeded = CIC_DEPENDENT;
          if(_el?.AWM_CICNeeded === "N/A") _el.AWM_CICNeeded = NOT_NEEDED;
          _el.Projected_FA_FullKit_Date = _el?.Projected_FA_FullKit_Date ? changeDateFormat(_el?.Projected_FA_FullKit_Date) : ""; //full kt date format
          return _el;
        });
        return el;
      });
      const { pxObjClass, ...rest } = obj;
      return rest;
    });
    store.dispatch(acpBookingData(arr));
  } else {
    store.dispatch(acpBookingData([]));
  }
  if (AcpBookingCapacityValuesResponse?.length) {
    store.dispatch(acpBookingCapacityValuesData(AcpBookingCapacityValuesResponse));
  } else store.dispatch(acpBookingCapacityValuesData([]));

  return AcpBookingResponse;
};
export const getACPDashboardProjectsRequiringPM = async (user_group, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
    },
  };
  let apiURL = `${DEVURL}/fetchACPDashboardDetails`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let AcpDashboardPMTableResponse = !AcpService.isUBN(response?.data?.ACPDashboard)
      ? response?.data?.ACPDashboard
      : {};
    if (
      !AcpService.isUBN(AcpDashboardPMTableResponse) &&
      Object.keys(AcpDashboardPMTableResponse)?.length
    ) {
      store.dispatch(acpDashboardProjectsRequiringPM(AcpDashboardPMTableResponse));
    } else store.dispatch(acpDashboardProjectsRequiringPM({}));
    return AcpDashboardPMTableResponse;
  } catch (error) {
    console.log(error);
  }
};
export const fetchInternalCapacityData = async (payLoad, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/fetchInternalCapacityDetails`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let acpInternalCapacityResponse = response?.data;
    if (!AcpService.isUBN(acpInternalCapacityResponse)) {
      return acpInternalCapacityResponse;
    } else return {};
  } catch (error) {
    console.log(error);
  }
};

const promiseAllForMultipleAPIs = async (apiUrls, user_group, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
    },
  };
  try {
    const responses = await Promise.all(
      apiUrls?.map((url) => {
        const res = axiosInstance(`${DEVURL}/${url}`, {
          data: payLoad,
          method: "POST",
        });
        return res;
      })
    );
    const data = responses?.map((response) => response?.data);

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const getACPDashboardAlerts = async (user_group, headers = {}) => {
  try {
    const urls = ["fetchShortTermAlerts", "fetchMediumTermAlerts", "fetchLongTermAlerts"];
    const res = await promiseAllForMultipleAPIs(urls, user_group, headers);
    const data = res?.map((el) => !AcpService.isUBN(el) && removeKey(el, "pxObjClass"));
    let ob = {};
    data?.forEach((el) => {
      for (let key in el) {
        ob[key] = el[key];
      }
    });
    return ob;
  } catch (err) {
    console.log(err);
  }
};

export const fetchExternalCapacityData = async (payLoad, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/fetchExternalCapacityDetails`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let acpExternalCapacityResponse = response?.data;
    if (!AcpService.isUBN(acpExternalCapacityResponse)) {
      return acpExternalCapacityResponse;
    } else return {};
  } catch (error) {
    console.log(error);
  }
};
export const importUpdateExternalCapacityData = async (payLoad, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/updateExternalCapacityData`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let acpExternalCapacityResponse = response?.data;
    if (!AcpService.isUBN(acpExternalCapacityResponse)) {
      return acpExternalCapacityResponse;
    } else return {};
  } catch (error) {
    console.log(error);
  }
};
export const importUpdateInternalCapacityData = async (payLoad, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/updateInternalCapacity`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let acpInternalCapacityResponse = response?.data;
    if (!AcpService.isUBN(acpInternalCapacityResponse)) {
      return acpInternalCapacityResponse;
    } else return {};
  } catch (error) {
    console.log(error);
  }
};

export const getPMPicklistData = async (user_group, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
    },
  };
  let apiURL = `${DEVURL}/fetchPM`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payLoad,
      method: "POST",
    });
    let AcpDashboardPMTableResponse = response?.data?.PMList;
    AcpDashboardPMTableResponse = !AcpService.isUBN(response?.data?.PMList)
      ? AcpService.filterPMObjects(response?.data?.PMList)
      : [];
    return AcpDashboardPMTableResponse;
  } catch (error) {
    console.log(error);
  }
};

export const getAcpBookingBacklogData = async (userInformation, user_group, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
      PM: userInformation?.userid,
    },
  };
  let apiURL = `${DEVURL}/fetchACPBookingBacklog`;
  const response = await axiosInstance({
    url: apiURL,
    data: payLoad,
    method: "POST",
  });
  let AcpBookingResponse = response?.data;
  let _AcpBookingResponse = AcpBookingResponse?.Backlog?.map((_el) => {
    if (_el?.RequestStatus === "Awaiting Response") _el.StartDate = _el?.UpdatedStartDate;
    //AWM-3993: updated CIC Needed values
    if(_el?.AWM_CICNeeded === "No") _el.AWM_CICNeeded = CIC_DEPENDENT;
    if(_el?.AWM_CICNeeded === "N/A") _el.AWM_CICNeeded = NOT_NEEDED;
    return _el;
  });
  return !AcpService.isUBN(AcpBookingResponse?.Backlog) ? _AcpBookingResponse : [];
};

export const updateRTATasks = async (formData) => {
  let headers = {};
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  // let apiURL = `https://pegasit.pg.com/prweb/api/ArtworkAgilityFile/v1/UpdateRTATasks`;
  let apiURL = `${DEVURL}/updateRTATasks`;
  const RTATasksResponse = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: formData,
  });

  if (Object.keys(RTATasksResponse?.data)?.length) {
    store.dispatch(updateRTATasksResponse(RTATasksResponse.data));
  }

  return RTATasksResponse?.data;
};

export const getBVELoopData = async (userInformation, user_group, headers = {}) => {
  const payLoad = {
    ArtworkAgilityPage: {
      UserGroup: user_group,
      PM: userInformation.userid,
    },
  };
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/fetchBVELoop`;

  // let apiURL = `https://pegasit.pg.com/prweb/api/ArtworkAgilityFile/v1/FetchBVELoop/Baby Care/EUROPE`;

  const response = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: payLoad,
  });
  let offTractBVELoop = response?.data?.OffTrackBVE || "";
  let onTractBVELoop = response?.data?.OnTrackBVE || "";
  let AcpBookingCapacityValuesResponse = response?.data?.CapacityValues;

  console.log("response bve booking ----->", offTractBVELoop, onTractBVELoop);

  if (AcpBookingCapacityValuesResponse?.length) {
    store.dispatch(acpBookingCapacityValuesData(AcpBookingCapacityValuesResponse));
  }

  if (response?.status === 200) {
    return { offTractBVELoop, onTractBVELoop };
  } else return { offTractBVELoop, onTractBVELoop };
};

/**
 * ACP Planning Task Get api.
 *
 * @getPlanningTaskLists
 * @param {Object} headers - holds the empty object.
 * @returns {Object} returns the response.
 */
export const getPlanningTaskLists = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let endpoint = "getACPTaskListPlanDetails";
  let apiURL = AcpService.getUrl(DEVURL, endpoint);
  try {
    const res = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: payload,
    });

    let AcpPlanningResponse = !AcpService.isUBN(res?.data?.TaskList) ? res?.data?.TaskList : [];
    AcpPlanningResponse = AcpPlanningResponse?.map((el)=>{
      el["Projected FA FullKit Date"] = el?.Projected_FA_FullKit_Date ? changeDateFormat(el?.Projected_FA_FullKit_Date) : "";
      return el
    })

    //filter FA assembly & Upload CIC
    store.dispatch(acpPlanningData([]));
    let filteredData = AcpPlanningResponse?.filter(
      (dataSet) =>
        dataSet?.TaskType?.toLowerCase().includes("ssembly") ||
        dataSet?.TaskType?.toLowerCase().includes("cic")
    );
    filteredData = filteredData.map((el) => {
      if (el?.RequestStatus === "Awaiting Response") el.NewStartDate = el?.UpdatedStartDate;
      if (el?.AWM_CICNeeded === "No") {el.AWM_CICNeeded = CIC_DEPENDENT};
      if (el?.AWM_CICNeeded === "N/A") {el.AWM_CICNeeded = NOT_NEEDED};
      el["Projected FA FullKit Date"] = el?.Projected_FA_FullKit_Date ? changeDateFormat(el?.Projected_FA_FullKit_Date) : "";// fixed full kit date dispalying empty by default
      return el;
    });

    const validFilteredData = filteredData?.filter(
      (ele) => ele.StartDate && !isNaN(new Date(AcpService.formatDate(ele.StartDate)))
    );
    const sortedData = validFilteredData?.sort((a, b) =>
      AcpService.getDateDifference(a.StartDate, b.StartDate)
    );
    if (sortedData?.length) {
      const addUniqueKey = (data) => {
        return data?.map((el, i) => {
          return {
            ...el,
            ...convertBooleanToString(el?.StagingPMPDetails), //AWM-4031
            CurrentStartDate: el.StartDate,
            ProjectID: el.AWMProjectID,
            Buffer: el.RemainingBuffer,
            UniqueID: i,
            Owner:el.PM,
          };
        });
      };
      const _acpPlanningDataWithKeys = addUniqueKey(sortedData);
      store.dispatch(acpPlanningData(_acpPlanningDataWithKeys));
    } else store.dispatch(acpPlanningData([]));

    return AcpPlanningResponse;
  } catch (error) {
    console.log(error.message);
  }
};

export const getPlanningProjectLists = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let endpoint = "getACPProjectListDetails";
  let apiURL = AcpService.getUrl(DEVURL, endpoint);

  try {
    const res = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: payload,
    });

    let AcpProjectCapacityResponse = !AcpService.isUBN(res?.data?.CapacityForProject)
      ? res?.data?.CapacityForProject
      : [];
    let AcpProjectListResponse = !AcpService.isUBN(res?.data?.ProjectListACP)
      ? res.data.ProjectListACP
      : [];
    // filter Draft and Active projects only
    store.dispatch(acpPlanningProjectData([]));
    store.dispatch(setAcpPlanningProjectCapacityValuesData([]));
    let filteredData = AcpProjectListResponse?.filter(
      (dataSet) => dataSet?.ProjectState === "Draft" || dataSet?.ProjectState === "Active"
    );
    const addUniqueKey = (data) => {
      return data?.map((el, i) => {
        return {
          ...el,
          Buffer: el.AWMRemainingBuffer,
          ProjectID: el.AWMProjectID,
          Owner: el.PM,
          UniqueID: i,
        };
      });
    };

    const sortedData = filteredData?.sort((a, b) =>
      AcpService.getDateDifference(a.EstimatedAWReadiness, b.EstimatedAWReadiness)
    );
    
    if (AcpProjectCapacityResponse?.length) {
      store.dispatch(setAcpPlanningProjectCapacityValuesData(AcpProjectCapacityResponse));
    } else {
      store.dispatch(setAcpPlanningProjectCapacityValuesData([]));
    }

    if (sortedData?.length) {
      const updatedSortedData = addUniqueKey(sortedData);
      store.dispatch(acpPlanningProjectData(updatedSortedData, AcpProjectListResponse));
      // Return the processed project data instead of raw response
      return updatedSortedData;
    } else {
      store.dispatch(acpPlanningProjectData([]));
      return [];
    }
  } catch (error) {
    console.log(error.message);
    return [];
  }
};

export const updateStoreAsEmpty = () => {
  store.dispatch(updateRTATasksResponse([]));
  return null;
};

export const updateEmptyErrorData = () => {
  store.dispatch(emptyErrorData());
};
export const fetchBookingCapacities = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/getCapacityForACPBooking`;
  const endDate = payload?.ArtworkAgilityPage?.End_Date;
  const startDate = payload?.ArtworkAgilityPage?.Start_Date;
  const endDateObj = AcpCommonService.parseCustomDate(endDate);
  const startDateObj = AcpCommonService.parseCustomDate(startDate);
  if (endDateObj >= startDateObj) {
    try {
      const res = await axiosInstance({
        url: apiURL,
        method: "POST",
        data: payload,
      });

      let capacityResponse = !AcpService.isUBN(res?.data) ? res?.data : [];
      return capacityResponse;
    } catch (error) {
      console.log(error.message);
    }
  }
};

export const planningMassUpdate = async (formData, type) => {
  let data = [];
  formData.forEach((el) => {
    let ob = {};
    if (type === "Task") {
      ob["AWMTaskID"] = el.AWMTaskID;
      ob["Start_Date"] = AcpService.changeDateFromISTtoUTC(el.NewStartDate);
    } else {
      ob["AWMProjectID"] = el.AWMProjectID;
      ob["Estimated_AWReadiness"] = AcpService.changeDateFromISTtoUTC(el.NewStartDate);
    }
    data.push(ob);
  });

  let finalData = {};
  if (type === "Task") {
    finalData = {
      NewStartDates: data,
    };
  } else {
    finalData = {
      NewReadinessDates: data,
    };
  }

  try {
    let headers = {};
    const api = new Api();
    const axiosInstance = await api.init({ headers });
    let apiURL =
      type === "Task"
        ? `${DEVURL}/massUpdateACPPlanningBooking`
        : `${DEVURL}/massUpdateACPPlanningProjList`;
    const massUpdateResponse = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: finalData,
    });
    return massUpdateResponse;
  } catch (error) {
    console.log(error.message);
  }
};

export const planningCloseProject = async (data) => {
  let _data = [];
  data.forEach((el) => {
    let ob = {};
    ob["AWMProjectID"] = el.AWMProjectID;
    _data.push(ob);
  });

  let finalData = {
    TaskList: _data,
  };

  try {
    let headers = {};
    const api = new Api();
    const axiosInstance = await api.init({ headers });
    let apiURL = `${DEVURL}/acpPlanningCloseProject`;
    const closeProjectResponse = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: finalData,
    });
    return closeProjectResponse;
  } catch (error) {
    console.log(error.message);
  }
};
export const massUpdateACPPlanningBooking = async (formData, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/massUpdateACPPlanningBooking`;
  const addResponse = await axiosInstance({
    url: apiURL,
    method: "POST",
    data: formData,
  });
  return { response: addResponse };
};

export const updateLongTermFile = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/uploadLongTermPlan`;

  try {
    const res = await axiosInstance({
      url: apiURL,
      method: "POST",
      data: payload,
    });
    return res;
  } catch (error) {
    console.log(error.message);
  }
};
export const updatePMPicklistData = async (payload, headers = {}) => {
  const api = new Api();
  const axiosInstance = await api.init({ headers });
  let apiURL = `${DEVURL}/updatePM`;
  try {
    const response = await axiosInstance({
      url: apiURL,
      data: payload,
      method: "POST",
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};
